import { gql } from '@grandvisionhq/graphql';

var StoreByIdFragment = gql`
  fragment StoreById on Store {
    code
    globalStoreId
    streetName
    streetNumber
    name
    town
  }
`;

export { StoreByIdFragment as default };
//# sourceMappingURL=store-by-id.js.map
